var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c("Modal", {
    staticClass: "resetPass",
    attrs: {
      width: "400",
      closable: false,
      "mask-closable": false
    },
    model: {
      value: _vm.statementOfAccountModal,
      callback: function callback($$v) {
        _vm.statementOfAccountModal = $$v;
      },
      expression: "statementOfAccountModal"
    }
  }, [_c("h3", {
    staticStyle: {
      padding: "0"
    },
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("提示")])]), _c("div", {
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-size": "14px"
    }
  }, [_vm._v("当前存在未确认的对账单，请及时确认。")]), _c("div", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("Button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handlerToStatementOfAccount
    }
  }, [_vm._v("跳转确认页面 "), _vm.pageTimeOut >= 0 ? _c("span", [_vm._v(" (" + _vm._s(_vm.pageTimeOut) + ")")]) : _vm._e()])], 1)]);
};

var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };